import { render, staticRenderFns } from "./AdminRetailerEdit.vue?vue&type=template&id=1a6b50b3"
import script from "./AdminRetailerEdit.vue?vue&type=script&lang=js"
export * from "./AdminRetailerEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminRetailerEdit.vue?vue&type=style&index=0&id=1a6b50b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports